import axios from '@utils/axios';
import router from '@router/router';
import i18n from '@utils/localization';

const viewUser = {
  state: {
    userId: 0,
    email: '',
    userName: '',
    color: 1,
    role: {},
    mainDoctor: false
  },
  mutations: {
    setUserId(state, id) {
      state.userId = id;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setUserName(state, userName) {
      state.userName = userName;
    },
    setColor(state, color) {
      state.color = color;
    },
    setRole(state, role) {
      state.role = role;
    },
    setMainDoctor(state, doctor) {
      state.mainDoctor = doctor;
    }
  },
  actions: {
    fetchUser(context, id) {
      return axios.get('admin/users/getuser', {
        params: {
          Id: id,
          Locale: i18n.locale
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.users.view' });
          } else if (res.status === 200) {
            context.commit('setUserId', id);
            context.commit('setEmail', res.data.result.email);
            context.commit('setUserName', res.data.result.userName);
            context.commit('setRole', res.data.result.role);
            context.commit('setColor', res.data.result.color);
            context.commit('setMainDoctor', res.data.result.isMainDoctor);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.users.view' });
        });
    }
  },
  namespaced: true
};

export default viewUser;
